<template>
  <el-dialog title="飞书通知配置" :visible.sync="dialogVisible" width="500px">
    <div class="fs-notify-container">
      选择商户号
      <el-tooltip effect="dark" content="当商户号有值时，将每周一 10:00:00 为@朱倩莹发送上周对应商户号的投诉单（按投诉类型）汇总数据" placement="top">
        <i class="el-icon-warning-outline" />
      </el-tooltip>
      <el-select v-model="wxMerchant" style="width: 300px;margin-left: 15px" multiple clearable filterable placeholder="请选择微信商户号">
        <el-option v-for="item in wxMerchantList" :key="item.mch_id" :label="item.mch_name" :value="item.mch_id"></el-option>
      </el-select>
    </div>


    <div slot="footer" class="dialog-footer">
      <el-button type="default" size="small" :loading="dialogLoading" @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" size="small" :loading="dialogLoading" @click="onSubmit">确 认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { wxMerchantFsMotifyOptionsApi, wxMerchantFsMotifySaveApi } from '@/api/merchant_complain_handle'
import { cloneDeep } from 'lodash'

export default {
  name: 'WxFsNotify',
  data() {
    return {
      dialogVisible: false,
      wxMerchantList: [],
      wxMerchant: [],
      originSelectData: [], // 上一次配置数据
      dialogLoading: false
    };
  },
  methods: {
    async triggleVisible () {
      this.wxMerchant = [];
      await this.handleGetMerchantSelect();
      this.dialogVisible = true;
    },

    async handleGetMerchantSelect () {
      wxMerchantFsMotifyOptionsApi().then(res => {
        const { data } = res.data
        const merchant = (data || []).map(it => {
          return {
            ...it,
            mch: it.mch.map(child => {
              return {
                ...child,
                mch_name: `${it.company_name}-${child.mch_name}`
              }
            })
          }
        })
        this.wxMerchantList = merchant.reduce((acc, it) => acc.concat(it.mch || []), []);

        const selected = this.wxMerchantList.filter(it => it.week_check === 1).map(it => it.mch_id)
        this.originSelectData = cloneDeep(selected)
        this.wxMerchant = cloneDeep(selected)
      }).catch(() => {})
    },

    onSubmit () {
      const prevIds = new Set(this.originSelectData || []);
      const currIds = new Set(this.wxMerchant || []);

      const addedIds = [...currIds].filter(id => !prevIds.has(id));
      const removedIds = [...prevIds].filter(id => !currIds.has(id));
      
      this.dialogLoading = true
      wxMerchantFsMotifySaveApi({
        add_mch_id: addedIds.join(','),
        remove_mch_id: removedIds.join(',')
      }).then(res => {
        this.$message.success('保存成功')
        this.dialogLoading = false
        this.dialogVisible = false
      }).catch(() => { this.dialogLoading = false })
    }
  }
};

</script>